import { api } from '@/api'

export interface ServicePlanPricePayload {
  region_id?: string | null
  currency_id: string
  pricing_type: string
  amount: string
  unit?: string | null
  billing_period?: string
  min_quantity?: number
  max_quantity?: number | null
  is_starting_from?: boolean
  is_official?: boolean
}

export interface CreateServicePlanPayload {
  name: string
  slug?: string
  description: string | null
  duration_days: number | null
  is_active: boolean
  sort_order: number
  is_popular?: boolean
  prices: ServicePlanPricePayload[]
}

export interface UpdateServicePlanPayload {
  name: string
  slug?: string
  description: string | null
  duration_days: number | null
  is_active: boolean
  sort_order: number
  is_popular?: boolean
  prices: ServicePlanPricePayload[]
}

export function createServicePlanAction(serviceSlug: string, payload: CreateServicePlanPayload) {
  return api.v2.post(`/services/${serviceSlug}/plans`, payload as unknown as Record<string, unknown>)
}

export function updateServicePlanAction(serviceSlug: string, planId: string, payload: UpdateServicePlanPayload) {
  return api.v2.put(`/services/${serviceSlug}/plans/${planId}`, payload as unknown as Record<string, unknown>)
}

export function deleteServicePlanAction(serviceSlug: string, planId: string) {
  return api.v2.delete(`/services/${serviceSlug}/plans/${planId}`)
}
